

export const parseValueProvider = (fields, values) => {
	var datas = {}

	Object.keys(values).map(function(key, index) {
	   if(fields.indexOf(key) != -1){
	    datas[key] = values[key]
	   }
	});

	return datas
}


export function capitalizeFirstLetter(string) {
	if(string)
    	return string.charAt(0).toUpperCase() + string.slice(1);
    return ""
}



// WEBPACK FOOTER //
// ./src/utils/parse.js